import React from 'react';
import {t} from "../../../components/Translate";

const FileSearch = ({ searchQuery, handleSearchChange, currentUser }) => {
    return (
        <div className="files-search-container">
            <input
                type="text"
                className="files-search-input"
                placeholder={t(currentUser.language, "searchByKeyName")}
                value={searchQuery}
                onChange={handleSearchChange}
            />
        </div>
    );
};

export default FileSearch;
